import type { RoadmapItemStatus } from "../types";

export const roadmapStatuses: Record<
  RoadmapItemStatus,
  { label: string; badge: string; dot: string }
> = {
  backlog: {
    label: "Backlog",
    badge: "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200",
    dot: "fill-gray-500 dark:fill-gray-400",
  },
  in_progress: {
    label: "In Progress",
    badge:
      "bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-200",
    dot: "fill-primary-600 dark:fill-primary-400",
  },
  review: {
    label: "Review",
    badge:
      "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
    dot: "fill-purple-600 dark:fill-purple-400",
  },
  blocked: {
    label: "Blocked",
    badge: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
    dot: "fill-red-600 dark:fill-red-400",
  },
  done: {
    label: "Done",
    badge: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
    dot: "fill-green-600 dark:fill-green-400",
  },
};
